import type {
    RibbonControlGroupDefinitionSLR,
    RibbonTabDefinitionBase,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { SingleLine } from 'owa-command-ribbon';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store';
import { getStringRibbonId, MailRibbonTabId } from 'owa-ribbon-ids';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import { getInitialScalingSteps } from '../../../../util/getInitialScalingSteps';
import { getScalingSteps } from '../../../../util/getScalingSteps';
import { getTabGroups } from '../../../../util/getTabGroups';
import { getToolbarMessageTabControlDefinition } from './getToolbarMessageTabControlDefinition';
import {
    controlsDontDropLabels,
    controlsDontMoveToOverflow,
    controlsWithoutLabels,
} from './toolbarMessageTabScalingSpecialCases';

const getToolbarMessageTab = computedFn(
    (props: RibbonControlDefinitionProps): RibbonTabDefinitionBase => {
        return {
            id: getStringRibbonId(MailRibbonTabId.Tab_Message),
            type: SingleLine,
            title: '',
            controlGroups: {
                type: SingleLine,
                groups: getToolbarMessageTabGroups(props),
            },
            initialScalingSteps: getInitialScalingSteps(
                getMailRibbonConfigStore.toolbar.messageTab,
                controlsWithoutLabels,
                props.popoutComposeViewState,
                undefined /*itemId */
            ),
            scalingSteps: getScalingSteps(
                getMailRibbonConfigStore.toolbar.messageTab.layout,
                getMailRibbonConfigStore.toolbar.messageTab.showLabelsPreference,
                controlsDontMoveToOverflow,
                controlsDontDropLabels,
                props.popoutComposeViewState,
                undefined /*itemId */
            ),
        };
    }
);
export default getToolbarMessageTab;

const getToolbarMessageTabGroups = computedFn(
    (props: RibbonControlDefinitionProps): RibbonControlGroupDefinitionSLR[] => {
        let toolbarMessageTabGroups: RibbonControlGroupDefinitionSLR[] = new Array();

        toolbarMessageTabGroups = getTabGroups(
            MailRibbonTabId.Tab_Message,
            getMailRibbonConfigStore.toolbar.messageTab.layout,
            getToolbarMessageTabControlDefinition,
            props
        );

        return toolbarMessageTabGroups;
    }
);
